var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedIconDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 11.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.63473 12.1118C2.85924 6.72574 7.38042 2.51031 12.7955 2.68792C18.0227 2.85867 22.1809 7.08198 22.3151 12.265C22.389 15.1194 21.2329 17.7629 19.2929 19.6277C17.2938 21.5477 14.5417 22.5736 11.6607 22.3397C6.43114 21.9134 2.41267 17.4214 2.63432 12.1118L2.63473 12.1118ZM15.5034 9.31922L11.2633 13.5598L9.49675 11.7917C9.10688 11.4018 8.47366 11.4018 8.08379 11.7917C7.69257 12.1816 7.69257 12.8149 8.08379 13.2048L10.5575 15.6788C10.9473 16.0687 11.5806 16.0687 11.9704 15.6788L16.9164 10.7309C17.3063 10.341 17.3063 9.70768 16.9164 9.31777C16.5266 8.92786 15.8933 8.92786 15.5035 9.31777L15.5034 9.31922ZM21.5142 3.84023C16.7321 -1.13725 8.81765 -1.2973 3.83965 3.48392C-1.13732 8.26658 -1.29735 16.1818 3.48475 21.1593C8.23732 26.1058 16.149 26.3278 21.1593 21.5142C26.159 16.7116 26.2774 8.79913 21.5142 3.84023Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIconDark);
export default __webpack_public_path__ + "static/media/checkedIconDark.826e4136cf6e3612f3ebb160e4d67349.svg";
export { ForwardRef as ReactComponent };